<template lang="pug">
time(:class="computedClasses" :datetime="props.datetime.toString()") {{ formattedDate }}
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { type TimeProps } from './Time.types';
import { timeDefaults } from './Time.defaults';

const props = withDefaults(defineProps<TimeProps>(), timeDefaults as any) as unknown as TimeProps;

const computedClasses = computed(() => {
  const baseClasses = [];

  if (props.size !== 'none') {
    baseClasses.push(`fs-${props.size}`);
  }

  baseClasses.push(`fw-${props.fontWeight}`);

  if (props.context !== 'none') {
    baseClasses.push(`text-${props.context}`);
  }

  return baseClasses.join(' ');
});

const formattedDate = computed(() => {
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
  };

  const date = new Date(props.datetime);
  return isNaN(date.getTime())
    ? 'Invalid Date'
    : date.toLocaleDateString('en-US', options);
});
</script>
